import { render, staticRenderFns } from "./PopupIframe.vue?vue&type=template&id=f5984c80&"
import script from "./PopupIframe.vue?vue&type=script&lang=js&"
export * from "./PopupIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports